<template>
  <sui-page>
    <!-- 페이지 헤더 -->
    <sui-page-header title="[Samples] Web Editor" />

    <!-- 페이지 컨텐츠 -->
    <sui-page-contents>
      <!-- 에디터 -->
      <div class="comm_view_wrap">
        <div class="btn_wrap">
          <button type="button" class="comm_btn_Reset" @click="onClickSetContent">setContent</button>          
          <button type="button" class="comm_btn_Reset" @click="onClickGetContent">getContent</button>
          <button type="button" class="comm_btn_Reset" @click="onClickSetHtml">setHtml</button>          
          <button type="button" class="comm_btn_Reset" @click="onClickGetHtml">getHtml</button>
          <button type="button" class="comm_btn_Reset" @click="onClickSetText">setText</button>
          <button type="button" class="comm_btn_Reset" @click="onClickGetText">getText</button>
          <button type="button" class="comm_btn_Reset" @click="onClickClear">clear</button>
          <button type="button" class="comm_btn_Reset" @click="onToggle">toggle</button>
          <button type="button" class="comm_btn_Reset" @click="onCheckSize">chekcSize</button>
          <button type="button" class="comm_btn_Reset" @click="onGetSize">getSize</button>
        </div>        
      </div>
      <sui-web-editor ref="editor1" />
      <sui-web-editor ref="editor2" :isViewer="isViewer" :height="200" style="width:400px" />
    </sui-page-contents>
  </sui-page>
</template>
<script>
export default {
  name: 'CompEditor',
  data() {
    return {
      isViewer: true,
      // 웹에디터데이터
      editorContents: '',
      editorContents2: '',
      viewerContents: `<!doctype html>
<html lang="en" dir="ltr">
<head>
<meta charset="utf-8">
<title>Samsung Electronics Global-EHS</title>
</head>
<body>
<!-- Common Style Area -->
 <style>
 body {
 font-family: 'NotoKrR', "맑은 고딕", "돋움", "굴림", sans-serif;
 box-sizing: border-box;
 font-size: 13px
 }
 table{
 border-spacing: 0;
 border-collapse: collapse;
 width: 100%;
 }
 .ar {
 text-align: right !important
 }
 .ac {
 text-align: center !important
 }
 .fl_r {
 display: flex;
 justify-content: flex-end;
 }
 .mrB05 {
 margin-bottom: 5px !important
 }
 .mrB10 {
 margin-bottom: 10px !important
 }
 .mrB15 {
 margin-bottom: 15px !important
 }
 .mrB20 {
 margin-bottom: 20px !important
 }
 .mrB25 {
 margin-bottom: 25px !important
 }
 .mrB30 {
 margin-bottom: 30px !important
 }
 .mrB40 {
 margin-bottom: 40px !important
 }
 .mrB50 {
 margin-bottom: 50px !important
 }
 .mrR10 {
 margin-right: 10px !important
 }
 textarea {
 font-family: 'NotoKrR', "맑은 고딕", "돋움", "굴림", sans-serif;
 font-size: 13px;
 color:#333;
 padding: 8px;
 border: 1px solid #ccc;
 resize: none;
 width: 100%;
 min-height: 100px;
 box-sizing: border-box;
 background-color:#f7f7f7
 }
 textarea:hover {
 border: 1px solid #a5a5a5
 }
 textarea:focus {
 border: 1px solid #2949b3
 }

 .mailWrap {
 border: 1px solid #ccc;
 padding: 24px;
 margin: 20px
 }
 .titleWrap {
 width: 100%;
 font-size: 18px;
 border-bottom: 1px solid #dbdbdb;
 padding-bottom: 15px;
 margin-bottom: 20px
 }
 .contentsWrap {
 }
 .contentsWrap p {
 font-size: 13px;
 color: #333;
 margin: 0;
 line-height: 23px;
 }
 .contentsWrap a {
 margin-top: 5px;
 font-size: 13px;
 color: #60a3ef;
 display: inline-block;
 }
 .stitle {
 margin-bottom: 10px;
 font-size: 13px;
 color: #000;
 font-weight: bold
 }
 .viewTB {
 width: 100%;
 empty-cells: show;
 border-top: 1px solid #ccc;
 }
 .viewTB th {
 background-color: #F6F7F9;
 height: 36px;
 text-align: left;
 padding-left: 8px;
 color: #333;
 border-bottom: 1px solid #eaeaea;
 }
 .viewTB td {
 font-size: 13px;
 height: 36px;
 background-color: #fff;
 border-bottom: 1px solid #eaeaea;
 margin: 0;
 color: #5a5a5a;
 white-space: nowrap;
 text-overflow: ellipsis;
 overflow: hidden;
 padding: 0 8px
 }
 .listTB {
 width: 100%;
 empty-cells: show;
 border-top: 1px solid #ccc;
 border-bottom: 1px solid #ccc
 }
 .listTB th {
 background-color: #F6F7F9;
 height: 36px;
 text-align: left;
 padding-left: 8px;
 color: #333
 }
 .listTB th:before {
 content: "|";
 padding-right:5px;
 color: #dbdbdb;
 }
 .listTB th:first-child:before {
 content: none
 }
 .listTB td {
 font-size: 13px;
 height: 36px;
 background-color: #fff;
 border-top: 1px solid #eaeaea;
 margin: 0;
 color: #5a5a5a;
 white-space: nowrap;
 text-overflow: ellipsis;
 overflow: hidden;
 padding:0 8px 0 17px
 }
 .listTB td:first-child {
 border-left: none;
 padding:0 8px 0 8px
 }
 .btnWrap {
 display: flex;
 justify-content: center;
 }
 .btnWrap .btnBr {
 cursor: pointer;
 font-size: 13px;
 color: #2949b3;
 background-color: #fff;
 border: 1px solid #2949b3;
 padding: 5px 8px
 }
</style>
<div class="mailWrap">
	<div class="titleWrap">Global <strong>EHS</strong></div>
 		<div class="contentsWrap">

<!--  Contents 사용자 작업영역-->
    <div class="stitle">설비기본정보</div> <!-- 기본정보 -->
		<div class="viewTB">
      <table>
        <colgroup>
          <col width="10%" />
          <col width="20%" />
          <col width="10%" />
          <col width="20%" />
          <col width="10%" />
          <col width="20%" />
        </colgroup>
        <tr>
          <th>설비ID</th>  <!-- 설비ID -->
          <td>Q990-000060-002</td>
          <th>설비명</th>  <!-- 설비명 -->
          <td>결재상신창 확인용</td>
          <th>설비분류</th>  <!--설비분류 -->
          <td>UT/보일러/관류식</td>
        </tr>
        <tr>
          <th>자산대상여부</th>  <!--자산대상 -->
          <td>N/
                      
                    </td>
          <th>Description</th>  <!-- Description -->
          <td colspan=3>PUMP (UT)</td>
        </tr>
        <tr>
          <th>수명연한</th>  <!--수명연한 -->
          <td>10년</td>
          <th>비고</th>  <!--비고 -->
          <td colspan=3>해당 설비는 비고입니다.</td>
        </tr>
      </table>
		</div>
    <div class="mrB30"></div>
    <div class="stitle">관리정보</div> <!-- 관리정보 -->
		<div class="viewTB">
      <table>
        <colgroup>
          <col width="10%" />
          <col width="20%" />
          <col width="10%" />
          <col width="20%" />
          <col width="10%" />
          <col width="20%" />
        </colgroup>
        <tr>
          <th>사업장</th>  <!-- 사업장  -->
          <td>수원</td>
          <th>GBM</th>  <!-- GBM -->
          <td>VD</td>
          <th>관리그룹</th>  <!--관리그룹 -->
          <td>유티운영파트</td>
        </tr>
        <tr>
          <th>수정자</th>  <!--수정자 -->
          <td>백정남</td>
          <th>수정일</th>  <!--수정일 -->
          <td>2019/11/07</td>
          <th>설치일</th>  <!--설치일 -->
          <td>2019/10/31</td>
        </tr>
        <tr>
          <th>설비위치</th>  <!--설비위치 -->
          <td>/1단지/Global EHS센터/3F</td>
          <th>설비상세위치</th>  <!--설비상세위치 -->
          <td>303호</td>
          <th>가동시작일</th>  <!--가동시작일 -->
          <td>2019/10/31</td>
        </tr>
        <tr>
          <th>가동상태</th>  <!--가동상태 -->
          <td colspan=5>가동</td>
        </tr>
      </table>
		</div>
		<div class="mrB10"></div>
    <div class="stitle">관리규격</div> <!-- 관리규격 -->
		<div class="listTB">
      <table>
        <colgroup>
          <col width="5%" />
          <col width="20%" />
          <col width="15%" />
          <col width="20%" />
          <col width="40%" />
        </colgroup>
        <tr>
          <th>No.</th>  <!-- No  -->
          <th>관리규격</th>  <!-- 항목 -->
          <th>값</th>  <!-- 값 -->
          <th>단위</th>  <!-- 단위  -->
          <th>비고</th>  <!-- 비고 -->
        </tr>
              <tr>
          <td>1</td>
          <td>1111111</td>
          <td>10</td>
          <td>m/s</td>
          <td></td>
        </tr>
              <tr>
          <td>2</td>
          <td>연료종류</td>
          <td>400</td>
          <td>N/A</td>
          <td></td>
        </tr>
              <tr>
          <td>3</td>
          <td>연료사용량</td>
          <td>500</td>
          <td>m³/hr</td>
          <td></td>
        </tr>
              <tr>
          <td>4</td>
          <td>증발량</td>
          <td>200</td>
          <td>ton/hr</td>
          <td></td>
        </tr>
              <tr>
          <td>5</td>
          <td>설계압력</td>
          <td>34</td>
          <td>kg/cm²</td>
          <td></td>
        </tr>
              <tr>
          <td>6</td>
          <td>관리온도</td>
          <td>10</td>
          <td>kg</td>
          <td></td>
        </tr>
              <tr>
          <td>7</td>
          <td>냉매량</td>
          <td>300</td>
          <td>m/s</td>
          <td></td>
        </tr>
            </table>
    </div>
    <div class="mrB10"></div>
    <div class="stitle">제조사정보</div> <!-- 제조사정보 -->
		<div class="viewTB">
      <table>
        <colgroup>
          <col width="10%" />
          <col width="20%" />
          <col width="10%" />
          <col width="20%" />
          <col width="10%" />
          <col width="20%" />
        </colgroup>
        <tr>
          <th>제조사</th>  <!--제조사 -->
          <td>삼송</td>
          <th>연락처</th>  <!--연락처 -->
          <td>02-3940-4956</td>
          <th>업체담당자</th>  <!--업체담당자 -->
          <td>김담당</td>
        </tr>
        <tr>
          <th>제조일</th>  <!--제조일 -->
          <td>2019/10/31</td>
          <th>모델명</th>  <!-- 모델명 -->
          <td>123-9856</td>
          <th>시리얼번호</th>  <!--Serial No -->
          <td>12-4564</td>
        </tr>
        <tr>
          <th>화폐</th>  <!--화폐 -->
          <td>KRW</td>
          <th>자산취득가</th>  <!--자산취득가 -->
          <td>
                      <p align='right'>10,000</p>
                    </td>
          <th>무상보증마감일</th>  <!--무상보증마감일 -->
          <td>2020/12/31</td>
        </tr>
      </table>
		</div>
    <div class="mrB30"></div>
    <div class="stitle">첨부파일</div> <!-- 첨부파일 -->
		<div class="listTB">
      <table>
        <colgroup>
          <col width="5%" />
          <col width="25%" />
          <col width="30%" />
          <col width="15%" />
          <col width="25%" />
        </colgroup>
        <tr>
          <th>No.</th>  <!-- No  -->
          <th>첨부항목명</th>  <!-- 첨부항목명 -->
          <th>첨부파일명</th>  <!-- 첨부파일명 -->
          <th>첨부파일크기</th>  <!-- 첨부파일 크기 -->
          <th>첨부 제외 사유</th>  <!-- 첨부제외사유  -->
        </tr>
              <tr>
          <td>1</td>
          <td>하자 보증증권</td>
          <td>한글 문서2.docx</td>
          <td><p style="text-align:right">16356</p></td>
          <td></td>
        </tr>
              <tr>
          <td>2</td>
          <td>도면</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>3</td>
          <td>시방서</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>4</td>
          <td>설계계산서</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>5</td>
          <td>장비제작 승인서</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>6</td>
          <td>시험성적서 Test Report</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>7</td>
          <td>측정자료</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>8</td>
          <td>운영관리 매뉴얼</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>9</td>
          <td>카타로그</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>10</td>
          <td>환경영향 평가서</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>11</td>
          <td>인허가서류</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>12</td>
          <td>건물 준공필증</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>13</td>
          <td>소방필증</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>14</td>
          <td>위험기계기구 검사필증</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>15</td>
          <td>법적 검사필증</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>16</td>
          <td>교육자료</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>17</td>
          <td>교육실적</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>18</td>
          <td>Spare Part List</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>19</td>
          <td>Owner Request</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>20</td>
          <td>공사업체 정보</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>21</td>
          <td>설계 Concept</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
              <tr>
          <td>22</td>
          <td>열쇠 List</td>
          <td></td>
          <td><p style="text-align:right">0</p></td>
          <td></td>
        </tr>
            </table>
    </div>
<!--  Contents 사용자 작업영역-->
		<!-- Global EHS DirectLink -->
		<div class="btnWrap">
			<button type="button" class="btnBr">Global EHS 바로가기</button>
		</div>
	</div>
</div>
</body>
</html>`,
    };
  },
  computed: {},
  watch: {},
  mounted() {    
  },
  methods: {
    onClickSetContent() { // setHtml과 동일
      this.$refs.editor2.setContent(this.$refs.editor1.getContent());
      this.$refs.editor1.setContent('<p>Hello CAFE </p>');
    },
    onClickGetContent() { // getHtml과 동일
      console.log(this.$refs.editor1.getContent());
    },
    onClickSetHtml() {
      this.$refs.editor2.setHtml(this.viewerContents);      
    },
    onClickSetText() {
      // this.$refs.editor2.setText(this.$refs.editor1.getText());   
      this.$refs.editor2.setContent(this.$refs.editor1.getText());   
    },
    onClickGetHtml() {
      console.log(this.$refs.editor1.getHtml());
    },
    onClickGetText() {
      console.log(this.$refs.editor1.getText());
    },
    onClickClear() {
      // this.$refs.editor1.clear();
      this.$refs.editor1.setContent();
    },   
    onToggle() {
      this.isViewer = !this.isViewer;
    },
    onCheckSize() {
      const isExcceed = this.$refs.editor1.isContentSizeExcceed();
      if (isExcceed) {
        // do nothing
      }
    },
    onGetSize() {
      const size = this.$refs.editor1.getTextSize();
      utils.messageBox('information', size);
    },
  },
};
</script>

<style scoped>
</style>
